import { FORGET_USER, FORGET_USER_SUCCESSFUL, FORGET_PASSWORD_API_FAILED, RESET_PASSWORD, RESET_FORGET_USER, IS_LOADING } from "./actionTypes";

export const forgetUser = (user, history) => {
  return {
    type: FORGET_USER,
    payload: { user, history },
  };
};

export const forgetUserSuccessful = (message) => {
  return {
    type: FORGET_USER_SUCCESSFUL,
    payload: message,
  };
};

export const userForgetPasswordError = (error) => {
  return {
    type: FORGET_PASSWORD_API_FAILED,
    payload: error,
  };
};

export const resetPassword = (user, history) => {
  return {
    type: RESET_PASSWORD,
    payload: { user, history },
  };
};

export const resetForgetUser = (user, history) => {
  return {
    type: RESET_FORGET_USER,
  };
};


export const isLoadingForgetUser = () => {
  return {
    type: IS_LOADING,
  };
};
